import React from 'react';

export default function Noop() {
  return <></>;
}
